module.exports = __webpack_public_path__ + "media/images/lb/299-b9d4dd9cefcc15c634c74b6b4806f3d3.svg";